// extracted by mini-css-extract-plugin
export var backdropBlur = "_k3-0";
export var contentCard = "_k3-5";
export var frame = "_k3-2";
export var image = "_k3-4";
export var imagePane = "_k3-3";
export var modal = "_k3-1";